import { useEffect, useState } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { auth, db } from '../Firebase_Config/firebase';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import './attackMitre.css';
//https://web3forms.com/

const GET_EMAIL = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });

  const [toastOpen, setToastOpen] = useState(false);
  const [toastSeverity, setToastSeverity] = useState('success');
  const [toastMessage, setToastMessage] = useState('');

  useEffect(() => {
    const fetchUserData = async () => {
      const user = auth.currentUser;
      if (!user) return;

      const userDocQuery = query(collection(db, 'users'), where('userId', '==', user.uid));
      const userDocSnapshot = await getDocs(userDocQuery);

      if (!userDocSnapshot.empty) {
        const userData = userDocSnapshot.docs[0].data();
        setFormData(prev => ({
          ...prev,
          name: userData.Name || '',
          email: userData.email || ''
        }));
      }
    };

    fetchUserData();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, message: e.target.value });
  };

  const showToast = (message, severity = 'success') => {
    setToastMessage(message);
    setToastSeverity(severity);
    setToastOpen(true);
  };

  const handleCloseToast = (_, reason) => {
    if (reason === 'clickaway') return;
    setToastOpen(false);
  };

  const onSubmit = async (event) => {
    event.preventDefault();

    const formDataToSend = {
      ...formData,
      access_key: "eeb7e415-06eb-495c-a9f8-075545b91e36"
    };

    const res = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify(formDataToSend)
    }).then((res) => res.json());

    if (res.success) {
      showToast("Email submitted successfully!", "success");
      setFormData(prev => ({ ...prev, message: '' }));
    } else {
      showToast("Failed to submit. Please try again.", "error");
    }
  };

  return (
    <div className="ContactContainer">
      <h1 className='helptitle'>Contact Form</h1>
      <br/>
      <div className='attack-card-accent'/>
      
      <form onSubmit={onSubmit}>
        <textarea
          className='OtherInputs'
          name="message"
          placeholder="Write Your Message Here.."
          value={formData.message}
          onChange={handleChange}
        />
        <button className='SubmitInput' type="submit">Submit Form</button>
      </form>

      <Snackbar open={toastOpen} autoHideDuration={4000} onClose={handleCloseToast} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <MuiAlert onClose={handleCloseToast} severity={toastSeverity} sx={{ width: '100%' }} elevation={6} variant="filled">
          {toastMessage}
        </MuiAlert>
      </Snackbar>
    </div>
  );
};



const AttackMitre = () => {
  const [showModal, setShowModal] = useState(true);
  const [hasPaidTrue, setHasPaidTrue] = useState(null);
  const [showContactModal, setShowContactModal] = useState(false);
  
    const getUserId = () => {
      const user = auth.currentUser;
      return user?.uid;
    };
  
    const fetchHasPaidTrue = async () => {
      try {
        const userId = getUserId();
        if (!userId) return;
  
        const userDocQuery = query(collection(db, 'users'), where('userId', '==', userId));
        const userDocSnapshot = await getDocs(userDocQuery);
  
        if (!userDocSnapshot.empty) {
          const userDocData = userDocSnapshot.docs[0].data();
          const getHasPaid = userDocData.HasPaid || false;
          setHasPaidTrue(getHasPaid);
        } else {
          console.log('User document not found');
          setHasPaidTrue(false); // default to false if not found
        }
      } catch (error) {
        console.error('Error fetching payment status:', error);
        setHasPaidTrue(false);
      }
    };
  
    useEffect(() => {
      fetchHasPaidTrue();
    });
  
    const isDisabled = hasPaidTrue === false;
    
  const handleContactClick = () => {
    setShowModal(false);
    setShowContactModal(true);
  };


  return (
    <div className='attackBG'>
      {hasPaidTrue === false && showModal && (
        <div className="Ai-modal-overlay">
          <div className="paid-modal-content">
            <button className="close-button" onClick={() => setShowModal(false)}>×</button>
             <button className="contact-button" onClick={handleContactClick}>Contact Us To Get Access</button>
          </div>
        </div>
      )}

      {showContactModal && (
        <div className="Ai-modal-overlay">
          <div className="paid-modal-content contact">
            <button className="close-button" onClick={() => setShowContactModal(false)}>×</button>
            <GET_EMAIL />
          </div>
        </div>
      )}
      <div className='attackMainContent'>
        <div className='attack-container'>
          <div className='attack-card-accent'/>
          <br/>
          <img src="ATLAS.png" alt="Logo" className='attack-image' />
          <div className='textContent'>
            {/*<h2 className='headingcenter'>The hub for Collaborative Learning, Zero Data Sharing</h2>
            <p className='textCenter'>A suite of tools for a customised, end-to-end responsible AI experience</p>*/}
            <div className='attackContainer'>
              <div className='attack2'>
                <div className='attackcolumns'>
                  <h2>What is ATLAS?</h2>
                  <p>ATLAS (Adversarial Threat Landscape for Artificial-Intelligence Systems) is a globally accessible, living knowledge base of adversary tactics and techniques against Al-enabled systems based on real-world attack observations and realistic demonstrations from Al red teams and security groups.</p>
                  <br/>
                  <p>There are a growing number of vulnerabilities in AI-enabled systems as the incorporation of AI increases the attack surfaces of existing systems beyond those of traditional cyberattacks. ATLAS is designed to raise community awareness and readiness for these unique threats, vulnerabilities, and risks in the broader AI assurance landscape.</p>
                  <br/>
                  <p>ATLAS is modeled after the MITRE ATT&CK® framework and its tactics, techniques, and procedures (TTPs) are complementary to those in ATT&CK.</p>
                </div>
                <div className='attackcolumns'>
                  <h2>Why ATLAS?</h2>
                  <p>ATLAS can be used to:</p>
                  <ul>
                    <li>Inform security analysts and AI developers/implementers of realistic threats to AI-enabled systems</li>
                    <li>Enable threat assessments and internal red teaming</li>
                    <li>Understand real-world adversary behaviors and mitigation pathways</li>
                    <li>Report unique real-world adversary attacks on AI-enabled systems</li>
                  </ul>
                </div>
              </div>
              <br />
              {hasPaidTrue && (
                <div className="button-group">
                  <a href="https://attack-website-1001643314106.us-central1.run.app/" target="_blank" rel="noopener noreferrer">
                    <button className="download-button" disabled={isDisabled}>
                      ATLAS
                    </button>
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AttackMitre;
